/* eslint-disable no-else-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-parens */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-destructuring */
/* eslint-disable indent */
/* eslint-disable function-paren-newline */

import './exam-desk-copy.scss';

const edcRequestForm = document.getElementById('hbg-edc-request-form');
if (edcRequestForm) {
  document.addEventListener('DOMContentLoaded', () => {
    // Remove books that are not the first book
    document.body.addEventListener('click', (event) => {
      if (event.target.closest('.edc-remove-book-btn')) {
        event.preventDefault();
        const bookSection = event.target.closest('.edc-form-single-book-section');
        if (bookSection) {
          bookSection.remove();
        }
      }
    });

    // Additional fields if quantity is greater than one
    document.body.addEventListener('change', (event) => {
        if (event.target.matches('select[name="quantity"]')) {
            const bookSection = event.target.closest('.edc-form-single-book-section');
            const quantity = parseInt(event.target.value, 10);
            const additionalFields = bookSection.querySelectorAll('.additional-fields-hide');
            additionalFields.forEach((field, index) => {
                if (index < quantity - 1) {
                    field.style.display = 'block';
                    field.classList.add('additional-copy-section');
                    const inputs = field.querySelectorAll('input, select, textarea');
                      inputs.forEach(input => {
                        input.classList.add('edc-required-field');
                      });
                } else {
                    field.style.display = 'none';
                    field.classList.remove('additional-copy-section');
                    const inputs = field.querySelectorAll('input, select, textarea');
                      inputs.forEach(input => {
                        input.classList.remove('edc-required-field'); // Remove class if not displayed
                    });
                }
            });
        }
    });

    // Remove courses that are not the first course
    document.body.addEventListener('click', (event) => {
      if (event.target.closest('.edc-remove-course-btn')) {
        event.preventDefault();
        const courseSection = event.target.closest('.edc-form-single-course-section');
        if (courseSection) {
          courseSection.remove();
        }
      }
    });

    // Counters to add unique ids to books and courses
    let bookCount = 1;
    let courseCount = 1;

    const addNewBook = (booksContainer) => {
      const currentBookCount = booksContainer.querySelectorAll('.edc-form-single-book-section').length;
      if (currentBookCount >= 5) {
        alert('You can only add up to 5 books per course.');
        return;
      }

      const firstBook = document.getElementById('edc-form-single-book-1');
      const newBook = firstBook.cloneNode(true);
      newBook.classList.add('edc-form-single-book-section');
      newBook.classList.remove('edc-hide');
      const reqFields = newBook.querySelectorAll('.edc-req-book-field');
      reqFields.forEach((element) => {
        element.classList.add('edc-required-field');
      });

      // Create a Unique ID for each new book
      bookCount += 1;
      newBook.id = `edc-form-single-book-${bookCount}`;

      // Find child element that needs a unique ID and update it
      const childElement = newBook.querySelector('.edc-title-lookup');
      if (childElement) {
        childElement.id = `search-form-${bookCount}`;
      }

      // Clear the input fields
      const inputs = newBook.querySelectorAll('input');
      inputs.forEach(input => input.value = '');

      // Handle quantity selection for new books
      const additionalFields = newBook.querySelectorAll('.additional-fields-hide');
      additionalFields.forEach(field => {
        field.style.display = 'none';
        field.classList.remove('additional-copy-section', 'edc-required-field');
      });

      // Append new book field to bottom of course section
      booksContainer.appendChild(newBook);
    };

    const addNewCourse = () => {
      const coursesContainer = document.querySelector('.edc-courses-section');
      const currentCourseCount = coursesContainer.querySelectorAll('.edc-form-single-course-section').length;
      if (currentCourseCount >= 5) {
        alert('You can only add up to 5 courses.');
        return;
      }

      const firstCourse = document.getElementById('edc-form-single-course-1');
      const newCourse = firstCourse.cloneNode(true);
      newCourse.classList.add('edc-form-single-course-section');

      // Create a Unique ID for each new course
      courseCount += 1;
      newCourse.id = `edc-form-single-course-${courseCount}`;

      // Clear the input fields and remove additional books.
      const inputs = newCourse.querySelectorAll('input');
      inputs.forEach(input => input.value = '');
      const extraBooks = newCourse.querySelectorAll('.edc-form-single-book-section');
      extraBooks.forEach((field, index) => {
        field.remove();
      });

      // Remove the hide class from the delete button if its not the first course
      const deleteBtn = newCourse.querySelector('.edc-remove-course-btn');
      if (deleteBtn.classList.contains('edc-hide')) {
        deleteBtn.classList.remove('edc-hide');
      }

      // Append new course section to the courses container
      coursesContainer.appendChild(newCourse);
    };

    // Attach event listeners to the buttons
    document.getElementById('edcAddCourseBtn').addEventListener('click', addNewCourse);

    // Use event delegation for the "Add Another Book" buttons
    document.querySelector('.edc-courses-section').addEventListener('click', (event) => {
      if (event.target && event.target.matches('.edcAddBookBtn')) {
        const courseSection = event.target.closest('.edc-form-single-course-section');
        if (courseSection) {
          const booksContainer = courseSection.querySelector('.edc-book-section');
          if (booksContainer) {
            addNewBook(booksContainer);
          }
        }
      }
    });
    // Attach event listener to the first course's "Add Another Book" button
    const firstCourseSection = document.getElementById('edc-form-single-course-1');
    const firstCourseBooksContainer = firstCourseSection.querySelector('.edc-book-section');
    const firstCourseAddBookBtn = firstCourseSection.querySelector('.edcAddBookBtn');

    if (firstCourseAddBookBtn) {
      firstCourseAddBookBtn.addEventListener('click', () => {
        addNewBook(firstCourseBooksContainer);
      });
    }
  });

  // Update country field by state selected
  document.addEventListener('DOMContentLoaded', () => {
    const state = document.getElementById('edc-request-address-state');
    const country = document.getElementById('edc-request-address-country');

    state.addEventListener('change', (event) => {
      const selectedOption = event.target.options[event.target.selectedIndex];

      if (selectedOption.classList.contains('edc-us-state')) {
        country.value = 'US';
      } else if (selectedOption.classList.contains('edc-ca-state')) {
        country.value = 'CA';
      } else {
        country.value = ''; // Clear or set default value if needed
      }
    });
  });

  // Function to handle form submission and API request
  const submitForm = async () => {
    // order id, 13 character timestamp
    const date = new Date();
    const timestamp = date.getTime();
    const orderId = `EDC${timestamp}`.substring(0, 13);
    // contact details
    const firstName = document.getElementById('edc-request-first-name').value;
    const lastName = document.getElementById('edc-request-last-name').value;
    const email = document.getElementById('edc-request-email').value;
    const phone = document.getElementById('edc-request-phone').value;
    const attnTo = document.getElementById('edc-request-attn').value;
    const institution = document.getElementById('edc-request-institution').value;
    const department = document.getElementById('edc-request-department').value;
    const position = document.getElementById('edc-request-position').value;
    const address1 = document.getElementById('edc-request-address-1').value;
    const address2 = document.getElementById('edc-request-address-2').value;
    const addressCity = document.getElementById('edc-request-address-city').value;
    const addressState = document.getElementById('edc-request-address-state').value;
    const zip = document.getElementById('edc-request-address-zip').value;
    const addressZip = zip.replace(/-$/, '');
    const addressCountry = document.getElementById('edc-request-address-country').value;

    // Collect course information
    const courses = [];

    const courseSections = document.querySelectorAll('.edc-courses-section > section');
    courseSections.forEach((courseSection, index) => {
      const course = {
        course_name: courseSection.querySelector('#edc-request-course-name').value,
        semester: courseSection.querySelector('#edc-request-course-semester').value,
        enrollment_num: courseSection.querySelector('#edc-request-course-enrollment').value,
        course_number: courseSection.querySelector('#edc-request-course-number').value,
        subject_area: courseSection.querySelector('#edc-request-course-subject').value,
        items: [],
      };

      const bookSections = courseSection.querySelectorAll('.edc-form-single-book-section');
      bookSections.forEach((bookSection) => {
        const rawAuthor = bookSection.querySelector('input[name="author"]').value;
        const formattedAuthor = rawAuthor.split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        const adtSections = [];
        const additionalCopySections = bookSection.querySelectorAll('.additional-copy-section');
        console.log(additionalCopySections);
        additionalCopySections.forEach((additionalCopySection) => {
          const additionalSection = {
            name: additionalCopySection.querySelector('.additional-field-name').value,
            position: additionalCopySection.querySelector('.additional-field-position').value,
            email: additionalCopySection.querySelector('.additional-field-email').value,
          };
          adtSections.push(additionalSection);
        });
        const book = {
          isbn: bookSection.querySelector('.edc-request-course-isbn').value,
          quantity: Number(bookSection.querySelector('select[name="quantity"]').value),
          title: bookSection.querySelector('input[name="title"]').value,
          author: formattedAuthor,
          bookstore_name: bookSection.querySelector('input[name="bookstore_name"]').value,
          contact: bookSection.querySelector('input[name="contact"]').value,
          copy_type: bookSection.querySelector('select[name="edc-copy-type"]').value,
          comments: bookSection.querySelector('input[name="comment"]').value,
          additional_copy_details: adtSections,
        };
        course.items.push(book);
      });

      courses.push(course);
    });

    // Create JSON object
    const data = {
      order_id: orderId,
      first_name: firstName,
      last_name: lastName,
      email,
      phone,
      institution,
      department,
      position,
      address: {
        street_address1: address1,
        street_address2: address2,
        city: addressCity,
        zip: addressZip,
        state: addressState,
        country: addressCountry,
      },
      newsletters_opt_in: false,
      insertUser: email,
      updateUser: email,
      attnTo,
      courses,
    };

    try {
      const jsonData = JSON.stringify(data);
      console.log(jsonData);
      const key = window.edc.key;
      const endpoint = window.edc.endpoint;

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Ocp-Apim-Subscription-Key': key,
        },
        body: jsonData,
      });

      if (!response.ok) {
        throw new Error('API request failed');
      }

      // Redirect to the confirmation page
      window.location.href = `https://hachettebookgroup.com/edc-confirmation?orderid=${encodeURIComponent(data.order_id)}`;
    } catch (error) {
      console.error('Error:', error);
    }
  };

  // Function to alert on blank fields
  const validateForm = () => {
    // email validation
    const email = document.getElementById('edc-request-email').value;
    if (email === '' || email.indexOf('@') === -1 || email.indexOf('.') === -1) {
      alert('Please enter a valid email address');
      document.getElementById('edc-request-email').classList.add('edc-missing-field');
      return false;
    } else {
      document.getElementById('edc-request-email').classList.remove('edc-missing-field');
    }

    // Bookstore contact email validation
    const bookstoreEmails = document.querySelectorAll('.edc-bookstore-email');
    for (let i = 0; i < bookstoreEmails.length; i += 1) {
      const emailField = bookstoreEmails[i];
      const contactEmail = emailField.value.trim();
      if (contactEmail !== '' && (contactEmail.indexOf('@') === -1 || contactEmail.indexOf('.') === -1)) {
        alert('Please enter a valid email address');
        emailField.classList.add('edc-missing-field');
        return false;
      } else {
        emailField.classList.remove('edc-missing-field');
      }
    }

    // Additional Field Email Validation
    const additionalFieldEmail = document.querySelectorAll('.additional-field-email');
    for (let i = 0; i < additionalFieldEmail.length; i += 1) {
      const emailField = additionalFieldEmail[i];
      const contactEmail = emailField.value.trim();
      if (contactEmail !== '' && (contactEmail.indexOf('@') === -1 || contactEmail.indexOf('.') === -1)) {
        alert('Please enter a valid email address');
        emailField.classList.add('edc-missing-field');
        return false;
      } else {
        emailField.classList.remove('edc-missing-field');
       }
    }

    const requiredFields = document.querySelectorAll('.edc-required-field');
    let hasEmptyFields = false;

    for (let i = 0; i < requiredFields.length; i += 1) {
      const field = requiredFields[i];
      if ('value' in field && field.value.trim() === '') {
        requiredFields[i].classList.add('edc-missing-field');
        hasEmptyFields = true;
        console.log('there are empty fields');
      } else {
        requiredFields[i].classList.remove('edc-missing-field');
      }
    }

    if (hasEmptyFields) {
      alert('There is an empty or invalid entry. Please correct the error to proceed.');
      return false; // Prevent form submission
    }

    const singleBook = document.querySelectorAll('.edc-form-single-book-section');
    if (singleBook.length < 1) {
      alert('Please add a book to your request form.');
      return false;
    }

    // Form is valid
    return true;
  };

  // Grab form fields and send to the approval app on submit
  document.getElementById('edc-request-form-submit').addEventListener('click', (event) => {
    event.preventDefault();
    if (!validateForm()) {
      return;
    }

    submitForm();
  });
}
